import { RemoteGetPerformanceReportForProfessionalsTopValidatedActivities } from 'data/usecases';
import { GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerformanceReportForProfessionalsTopValidatedActivities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetPerformanceReportForProfessionalsTopValidatedActivities =
  (): GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface =>
    new RemoteGetPerformanceReportForProfessionalsTopValidatedActivities(
      makeApiUrlPerformanceReportForProfessionalsTopValidatedActivities(),
      makeAxiosHttpClient(),
    );
